export const daysSinceFirstOfMonth = (month: number, year: number): number => {
  const firstOfMonth = new Date(year, month - 1, 1);
  const today = new Date();
  const diffInMs = today.getTime() - firstOfMonth.getTime();
  const daysPassed = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  return daysPassed;
};
